import { useCallback, useEffect, useRef, useState } from 'react';
import Form from 'devextreme-react/form';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box';

import { t } from 'i18next';
import { IProductGroup, IUser } from '@/core/interfaces/usestate-interfaces';
import { useNavigate, useParams } from 'react-router-dom';
import { productGroupService } from '@/projects/platform/services/product-group-service';
import { Required } from '@/core/helper/validation-rule-helper';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';

function ProductGroupDefinition() {

    const params = useParams();
    const formRef: any = useRef<Form>();
    const [accounts, setAccount] = useState([]);
    const [parentProductGroups, setProductGroups] = useState([]);
    const [productGroup, setProductGroup] = useState<IProductGroup>({ id: '', parentId: null, name: '' });
    const navigate = useNavigate();

    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const userForm = formRef.current.props.formData;
                if (params.id) {
                    await productGroupService.updateProductGroup(null, userForm)
                } else {
                    const res: any = await productGroupService.createProductGroup(userForm);
                    navigate(`/product-group-definition/${res.id}`, { state: { id: res.id } })
                }
                resolve();
            } catch (error) {
                reject(error)
            }

        })
    }, []);



    useEffect(() => {
        (async function () {
            if (params.id && productGroup.id == '') {
                const getUser = await productGroupService.getProductGroup(params.id);
                const data = getUser.data;
                setProductGroup({ id: params.id, name: data.name, parentId: data.parentId });
            }
        })();

        const productGroups = async () => {
            const productGroups = await productGroupService.listProductGroup({});
            setProductGroups(productGroups.data);
        }

        productGroups();
    }, [productGroup])

    const parentProductGrouptEditorOptions = {
        dataSource: parentProductGroups,
        displayExpr: 'name',
        valueExpr: 'id',
    };

    return (

        <FormWrapper
            onSubmit={handleSubmit}
            formRef={formRef}
            formData={productGroup}
            backButtonNavigationPath='/product-group-list'
            buttonGroups={[
                { buttonOptions: BUTTON_CONSTANTS.SaveBtn }
            ]}
            simpleItemGroups={[
                {
                    caption: t('new_product_group'),
                    items: [
                        {
                            dataField: 'parentId',
                            editorType: 'dxSelectBox',
                            editorOptions: parentProductGrouptEditorOptions,
                            label: 'parent_product_group'
                        },
                        {
                            dataField: 'name',
                            label: 'product_group_name',
                            validationRules: [
                                { type: 'required', message: Required(t('name')) }
                            ]
                        }
                    ]
                }
            ]}
        />

    );
}

export default ProductGroupDefinition;
